<template>
  <div class="factoring-container">
    <div class="project-table">
      <avue-crud
        ref="crud"
        :option="tableConfig"
        :data="tableData"
        v-model="form"
        :page.sync="page"
        :search.sync="searchForm"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @selection-change="selectionChange"
        @row-click="handleRowClick"
      >
        <template slot="filesForm">
          <div class="upload-container">
            <WordUpload
              @showFileName="showFileName"
              fileMenuName="客户拜访附件"
              :id="id"
              :plain="true"
              :tip="true"
            />
            <div class="">
              <template v-for="(item, index) in form.file">
                <div class="file_wrapper" :key="index">
                  <a
                    class="file_button"
                    target="_blank"
                    :href="
                      isWord(item.fileUrl)
                        ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                          item.fileUrl
                        : item.fileUrl
                    "
                    type="text"
                    size="small"
                  >
                    {{ item.fileName }}
                  </a>
                  <i
                    @click="downLoadFile(item.id)"
                    class="el-icon-download del_icon"
                  ></i>
                  <i
                    @click="delFile(item.id, index, 'file')"
                    class="el-icon-circle-close del_icon"
                  ></i>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template slot="menuLeft">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click.stop="handleAdd()"
            v-if="!readOnly"
            >新建拜访
          </el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            plain
            v-if="!readOnly"
            @click.stop="handleEdit()"
            >修改
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            v-if="!readOnly"
            @click.stop="handleDelete()"
            >删除
          </el-button>
        </template>
      </avue-crud>
    </div>
    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />

    <SelectDepartment
      ref="selectdepartment"
      :checkdepartment="checkdepartment"
      :isOnly="true"
      @setDepartment="setDepartment"
    />
  </div>
</template>
<script>
import { downLoadTemplate } from "@/router/downLoadTem";
import { visitTableConfig } from "./config";
import * as dictionaries from "@/api/zd/dictionaries";
import { getList, deleteVisit, getDemandList } from "@/api/zd/visit";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import WordUpload from "@/components/wordUpload/wordUpload";
export default {
  name: "visit",
  data() {
    return {
      selectionList: [],
      checkUserList: [],
      checkdepartment: [],
      form: {},
      files: "",
      drawer: false,
      id: "",
      tableConfig: visitTableConfig(
        this.selectDeptClick,
        this.selectPersonClick
      ),
      sortOption: "",
      optionColumn: {},
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
    };
  },
  components: {
    SelectPerson,
    SelectDepartment,
    WordUpload,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.sortOption = this.tableConfig.column;
    this.queryTableData();
  },
  methods: {
    queryDemandList() {
      let self = this;
      getDemandList().then((res) => {
        self.demandList = res.data.data;
        self.needsOption.column[3].dicData = self.demandList;
      });
    },

    selectionChange(list) {
      this.selectionList = list;
    },

    saveData(row) {
      this.$refs.cloudtage.save(row);
    },
    //获取 人员名称
    getVisitPeople() {
      let visitPeople = this.checkUserList.map((item) => {
        return item.realName;
      });

      this.form.visitPeopleNames = visitPeople.join(",");
    },
    // 人员选择插件打开
    selectPersonClick() {
      this.$refs.selectperson.showmode();
    },

    //人员 获取
    setPeople(val) {
      this.checkUserList = val;
      this.getVisitPeople();
    },
    //部门选择插件打开
    selectDeptClick(department) {
      this.$refs.selectdepartment.showModel();
    },
    //部门 获取
    setDepartment(data = []) {
      this.checkdepartment = data;
      let titleList = data.map((item) => {
        return item.title || item.fullName;
      });
      let ids = data.map((item) => {
        return item.key;
      });

      this.form.managerDeptName = titleList.join(",");
      this.form.managerDeptId = ids.join(",");
    },
    searchChange(str, done) {
      this.queryTableData();
      done();
    },

    async queryTableData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        custId: this.$route.params.id,
      };
      let res = await getList(params);
      if (res.data.code == 200) {
        let data = res.data.data.list;
        data.map((item) => {
          item.demand = item.demand ? item.demand.split(",") : [];
        });
        this.tableData = data;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },

    //点击行跳转详情
    handleRowClick(row, event, column) {
      this.$router.push({ path: `/zd/visit/detail/${row.id}` });
    },

    //新增
    handleAdd() {
      this.$router.push({
        path: `/zd/visit/add/-1`,
        query: { goBack: true, custId: this.$route.params.id },
      });
    },

    handleEdit() {
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行编辑");
      } else if (this.selectionList.length == 1) {
        let data = this.selectionList[0];
        // this.$refs.crud.rowEdit(data);
        this.$router.push({
          path: `/zd/visit/edit/${data.id}`,
          query: { goBack: true },
        });
      } else {
        this.$message.error("请选择一条数据进行编辑");
      }
    },

    handleDelete() {
      let self = this;
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行删除");
      } else if (this.selectionList.length == 1) {
        this.$confirm("确定删除选择的数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
           
            let data = this.selectionList[0];
            let res = await deleteVisit({ id: data.id });
            if (res.data.code == 200) {
              self.$message({
                type: "success",
                message: "删除成功",
              });
              self.queryTableData();
            }
          })
          .catch(() => {
            // self.$message({
            //   type: "info",
            //   message: "已取消删除",
            // });
          });
      } else {
        this.$message.error("请选择数据进行删除");
      }
    },

    // 删除参数ids 提取this.selectionList中的id用,隔开成字符串
    async deleteData() {
      let ids = this.selectionList.map((item) => {
        return item.id;
      });
      let res = await deleteVisit({ id: ids.join(",") });
      if (res.data.code == 200) {
        this.$message.success("删除成功");
        // 刷新列表
        this.queryTableData();
      }
    },
    //下载附件
    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
    //删除附件
    delFile(fileId, index, name) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return dictionaries.deleteFile({
            fileId,
          });
        })
        .then(() => {
          this.form[name].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },
    //附件内容
    showFileName(data) {
      this.form.file = data;
      // this.form.fileId = data.id;
    },
  },
};
</script>
<style lang="scss" scoped>
.factoring-container {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
/deep/ .avue-crud__menu {
  min-height: 0;
}
</style>
<style lang="scss">
.factoring-container {
  .el-table__fixed,
  .el-table__fixed-right {
    height: calc(100% - 10px) !important;
  }
  .el-table__fixed-footer-wrapper {
    display: none !important;
  }
}
</style>